import type { HTMLAttributes } from 'react'
import { SkeletonTable } from '../../components/ui/skeleton'

type ListSkeletonProps = HTMLAttributes<HTMLDivElement> & { columns?: number[]; rows?: number }

export function ListSkeleton({
  columns = [2, 1, 1, 0.75],
  rows = 6,
  className,
  ...props
}: ListSkeletonProps) {
  return (
    <div
      {...props}
      data-slot="list-skeleton"
      className={['w-full', className].filter(Boolean).join(' ')}
    >
      <SkeletonTable columns={columns} rows={rows} />
    </div>
  )
}
